import { Button, Center, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Spacer, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

function SairChamada(props) {
  const disclosure = props.disclosure;
  const navigate = useNavigate();
  return (
    <>
      <Modal isOpen={disclosure.isOpen} isCentered>
        <ModalOverlay />
        <ModalContent maxW="95%" h="auto" borderRadius="0.8em">
          <ModalBody>
            <VStack mt={'0.8em'}>
              <Text color={'#616161'} fontWeight={'bold'} fontSize={'1.5em'} lineHeight={'1.2em'} textAlign={'center'}>
                Deseja realmente <br /> sair da chamada?
              </Text>
              <Text color={'#616161'} textAlign={'justify'} fontSize={'17px'} letterSpacing={'-0.05em'}>
                Você será redirecionado para o menu inicial do app e poderá retornar caso o médico não finalize o atendimento. Após ser finalizado,
                não será possível retornar
              </Text>
            </VStack>
            <Center w={'100%'} mt={'1em'} mb={'0.8em'}>
              <HStack align={'center'} w={'100%'}>
                <Button w={'100%'} color={'white'} bg={'red'} borderRadius={'0.8em'} onClick={() => navigate('/dashboard')}>
                  Sair da chamada
                </Button>
                <Button
                  color={'white'}
                  bg={'#5ab2ae'}
                  borderRadius={'0.8em'}
                  w={'100%'}
                  onClick={() => {
                    disclosure.onClose();
                  }}
                >
                  Ficar na chamada
                </Button>
              </HStack>
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default SairChamada;
